const UseExtractTax = () => {
	const bodyClass = document.body?.className;
	if (bodyClass) {
		// Define a regular expression to match /tax-value
		const taxValueRegex = /tax-([\w]+)/;

		// Use the regular expression to find a match in the body class
		const match = taxValueRegex.exec(bodyClass);

		// Extract the value part of the matched string (if any)
		const extractedValue = match ? match[1] : null;

		return extractedValue;
	}

	return null;
};

export default UseExtractTax;
